import { css } from '@emotion/react';
export const cssAdditionalRow = css `
    gap: 10px;
    padding: 10px 10px 10px 0;
    display: flex;
    align-items: flex-start;
`;
